import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const SadApikoIcon = ({ color, ...props }) => (
  <svg
    {...helpers.getSvgDimensionsProps(props)}
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd"
      fill="#333"
      d="M246.783 22.025c24.752 14.8 44.294 34.936 58.81 60.57s21.59 54.114 21.402 85.632v135.19c0 8.734-2.79 16.14-8.56 22.025-5.583 5.886-12.84 8.734-21.59 8.734-8.56 0-15.82-2.848-21.588-8.734-5.77-5.696-8.56-13.1-8.56-22.025v-1.14c-5.584 4.556-11.725 8.544-18.053 12.34-24.753 14.24-53.042 21.456-84.68 21.456s-59.927-7.026-84.866-21.456c-24.94-14.24-44.48-34.177-58.253-59.62-.093-.095-.14-.238-.186-.38s-.093-.285-.186-.38l-.558-.2a178.15 178.15 0 0 1-12.842-33.037l-1.675-6.646-.558-2.658c-.744-2.848-1.303-5.886-1.86-8.924 0-.2-.047-.38-.093-.57a2.43 2.43 0 0 1-.093-.569c-.558-3.418-1.117-6.836-1.49-10.253v-.38c-.372-3.608-.744-7.215-.93-11.013v-.2C.186 176.01 0 172.024 0 168.226c0-31.518 7.072-60 21.403-85.632s34.058-45.76 59.183-60.57C105.71 7.405 133.44 0 163.963 0s58.067 7.215 82.82 22.025zM48.576 167.85c0 64.937 51.553 117.34 115.017 117.34S278.61 232.786 278.61 167.85 227.242 50.51 163.593 50.51 48.576 103.103 48.576 167.85z"
    />
    <path
      fill="#bacace"
      d="M203.16 206.24a56.45 56.45 0 0 0-40.18-16.643c-15.178 0-29.447 5.9-40.18 16.643a3.68 3.68 0 0 0 0 5.206c1.438 1.437 3.77 1.437 5.206 0a49.13 49.13 0 0 1 34.973-14.487 49.13 49.13 0 0 1 34.973 14.487 3.67 3.67 0 0 0 5.207 0c1.437-1.438 1.437-3.77 0-5.206zm-26.422 1.996a30.78 30.78 0 0 0-14.218-3.483c-4.948 0-9.863 1.205-14.215 3.483-1.8.944-2.497 3.168-1.554 4.97a3.68 3.68 0 0 0 4.97 1.553c3.302-1.73 7.036-2.643 10.8-2.643a23.37 23.37 0 0 1 10.803 2.644 3.66 3.66 0 0 0 1.705.421c1.325 0 2.606-.72 3.264-1.975.942-1.8.246-4.025-1.554-4.97zM120.96 120c-2.034 0-3.682 1.65-3.682 3.682 0 10.806-8.8 19.597-19.597 19.597A3.68 3.68 0 0 0 94 146.96c0 2.033 1.648 3.682 3.68 3.682 14.866-.001 26.96-12.094 26.96-26.96 0-2.033-1.648-3.682-3.68-3.682zm106.4 23.278c-10.806 0-19.597-8.8-19.597-19.597a3.681 3.681 0 1 0-7.363 0c0 14.866 12.094 26.96 26.96 26.96 2.034 0 3.682-1.65 3.682-3.682a3.68 3.68 0 0 0-3.681-3.681zm-108.805 4.368a13.64 13.64 0 0 0-13.62 13.62 13.64 13.64 0 0 0 13.62 13.62 13.64 13.64 0 0 0 13.62-13.62 13.64 13.64 0 0 0-13.62-13.62zm87.932 0a13.64 13.64 0 0 0-13.62 13.62 13.64 13.64 0 0 0 13.62 13.62 13.64 13.64 0 0 0 13.62-13.62c.001-7.5-6.1-13.62-13.62-13.62z"
    />
  </svg>
);

SadApikoIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

SadApikoIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(327, 337),
};

export default SadApikoIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/sad-apiko.js